/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::983b2ea888da3676316ee009e2e8ccef>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const VideoPauseOverlayIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M2.75 3c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25zm7 0c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M2.75 3c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25zm7 0c0-.69.56-1.25 1.25-1.25h1c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-1c-.69 0-1.25-.56-1.25-1.25z"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
VideoPauseOverlayIcon.displayName = 'VideoPauseOverlayIcon';
var _default = exports.default = VideoPauseOverlayIcon;